import { temAcesso } from '@/shared/auth/temAcesso'

const Pesquisa = () => import('./Pesquisa.vue')
const Respostas = () => import('./Respostas.vue')
const RespostaDetalhes = () => import('./RespostaDetalhes.vue')

export default {
    path: 'pesquisas',
    name: 'Pesquisas',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: ':pesquisaId/responder',
            name: 'Pesquisas_Responder',
            component: Pesquisa,
            beforeEnter: (to, from, next) => {
                next()
            }
        },
        {
            path: 'respostas',
            name: 'Pesquisas_Respostas',
            component: Respostas,
            beforeEnter: (to, from, next) => {
                if (temAcesso('PESQUISAS-00')) {
                    next()
                }
            },
            children: [
                {
                    path: ':respostaId',
                    name: 'Pesquisas_Respostas_Detalhar',
                    component: RespostaDetalhes,
                    beforeEnter: (to, from, next) => {
                        if (temAcesso('PESQUISAS-00')) {
                            next()
                        }
                    }
                }
            ]
        }
    ]
}
